// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { clone16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-clone': IconClone;
    }
}

/**
 * The icon component for the 'clone' icon
 */
export class IconClone extends Icon {
    public constructor() {
        super(clone16X16);
    }
}

registerIcon('icon-clone', IconClone);
export const iconCloneTag = 'nimble-icon-clone';
